import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getDict as _getDict } from "@/utils/dictionary";
export default {
  data: function data() {
    return {
      page: 1,
      total: 10,
      pageSize: 10,
      tableData: [],
      searchInfo: {},
      tableLoading: false
    };
  },
  methods: {
    filterDict: function filterDict(value, type) {
      var rowLabel = this[type + "Options"] && this[type + "Options"].filter(function (item) {
        return item.value == value;
      });
      return rowLabel && rowLabel[0] && rowLabel[0].label;
    },
    getDict: function () {
      var _getDict2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(type) {
        var dicts;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return _getDict(type);
            case 1:
              dicts = _context.sent;
              this[type + "Options"] = dicts;
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDict(_x) {
        return _getDict2.apply(this, arguments);
      }
      return getDict;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    getTableData: function () {
      var _getTableData = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var page,
          pageSize,
          table,
          _args2 = arguments,
          _t;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              page = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : this.page;
              pageSize = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : this.pageSize;
              _context2.prev = 1;
              this.tableLoading = true;
              _context2.next = 2;
              return this.listApi(_objectSpread({
                page: page,
                pageSize: pageSize
              }, this.searchInfo));
            case 2:
              table = _context2.sent;
              this.tableData = table.data.list;
              this.total = table.data.total;
              this.page = table.data.page;
              this.pageSize = table.data.pageSize;
              this.tableLoading = false;
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t = _context2["catch"](1);
            case 4:
              _context2.prev = 4;
              this.tableLoading = false;
              return _context2.finish(4);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function getTableData() {
        return _getTableData.apply(this, arguments);
      }
      return getTableData;
    }()
  }
};